export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfBxc4AMP6lbBP.755330ea.woff2";